// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeOffHolidays_wrapper__lO-mL","controls":"TimeOffHolidays_controls__IW3tw","searchWrapper":"TimeOffHolidays_searchWrapper__YRYYE"};